import axios from '../utils/axios'

function request(functionId, body) {
  let data = {
    functionId,
    body,
  }
  return axios.request({
    data: data,
    method: 'post'
  })
}


// 获取租户信息
export function getContentTenantByUrlFlag(body) {
  return request('health_cmp_getContentTenantByUrlFlag', body);
}

// 获取用户信息
export function getContentUserInfo(body) {
  return request('health_cmp_biz_queryContentUser', body);
}
// 获取用户是否为医生
export function getDoctorType(body) {
  return request('health_cmp_biz_getDoctorInfoByPin', body);
}

// 添加或修改用户信息
export function saveOrUpdateContentUser(body) {
  return request('health_cmp_biz_saveOrUpdateContentUser', body);
}


//菜单
export function listContentUserPermissions(body) {
  return request('health_cmp_biz_listUserPermissions', body);
}

// 根据名称查询原始作者信息
export function getOriginalAuthorsByName(body) {
  return request('health_cmp_listByDoctorName', body);
}

// 根据业务名获取业务信息
export function getContentBusinessByName(body) {
  return request('health_cmp_getContentBusinessByName', body);
}

// 获取用户开通的业务、栏目、频道信息
export function listContentBizDetailByPin(body) {
  return request('health_cmp_biz_listUserContentBusiness', body);
}

//文章-获取疾病
export function queryDiseases(body) {
  return request('health_cmp_pageDiseaseInfoByParam', body);
}

// 获取标签信息(文章标签)
export function listContentUserLabels(body) {
  return request('health_cmp_biz_listContentUserLabels', body)
}

// 获取用户的文章类型
export function listArticleTypesByPin(body) {
  return request('health_cmp_biz_listUserContentTypes', body)
}

// 保存或跟新文章
export function saveOrUpdateArticle(body) {
  return request('health_cmp_biz_writerSaveOrUpdateArticle', body)
}
//全部文章类型
export function listAllArticleTypes(body) {
  return request('health_cmp_listAllArticleTypes', body);
}

// 获取用户的文章列表
export function pageArticlesByPin(body) {
  return request('health_cmp_biz_writerPageContentArticle', body);
}

// 预览文章
export function getPreviewInfoByIdForPin(body) {
  return request('health_cmp_getPreviewInfoByIdForPin', body);
}

// 下线 auditStatus:7
export function applyOfflineForPin(body) {
  return request('health_cmp_biz_writerUpdateArticleStatus', body);
}

//  撤销申请下线 auditStatus:3
export function cancelApplyOfflineForPin(body) {
  return request('health_cmp_biz_writerUpdateArticleStatus', body);
}

//  撤销投稿 auditStatus:1
export function cancelApplyArticleForPin(body) {
  return request('health_cmp_biz_writerUpdateArticleStatus', body);
}

// 删除草稿
export function deleteDraftForPin(body) {
  return request('health_cmp_biz_deleteDraftArticle', body);
}

// 置顶文章
export function topWriterArticle(body) {
  return request('health_cmp_biz_writerTopArticle', body);
}

//文章-预览文章
export function previewArticle(body) {
  return request('health_cmp_getPreviewInfoByIdForPin', body);
}
//个人中心-申请业务权限
export function listContentBusiness(body) {
  return request('health_cmp_biz_listUserAllBusiness', body);
}

//视频-获取地址
export function getVodUploadUrl (body) {
  return request('health_cmp_biz_getUploadUrl', body);
}

//视频-删除上传视频
export function deleteUploadedVod (body) {
  return request('health_cmp_biz_deleteUploadedVideo', body);
}

//视频-设置视频封面
export function setVideoCover (body) {
  return request('health_cmp_biz_setVideoCover', body);
}

//视频-设置视频封面
export function searchArticleById (body) {
  return request('health_cmp_business_getArticleById', body);
}

// 疾病百科-- 根据关键词查询疾病名称
export function searchDiseaseInfoByParam(body) {
  return request("health_cmp_manSearchDiseaseInfoByParam", body);
}

// 疾病百科-获取科室
export function queryDepartments (body) {
  return request('health_cmp_queryDepartments', body);
}

// 疾病百科-获取疾病默认的段落字典信息
export function getContentParagraphDictionary (body) {
  return request('health_cmp_getContentParagraphDictionary', body);
}
// 疾病百科-添加或更新疾病百科信息
export function saveOrUpdateDiseaseInfo (body) {
  return request('health_cmp_saveOrUpdateDiseaseInfo', body);
}

// 疾病百科-获取疾病特殊标签
export function pageContentLabelGroups (body) {
  return request('health_cmp_biz_pageContentLabelGroup', body);
}

// 疾病百科-获取疾病特殊标签
export function getDiseaseInfgoDetail (body) {
  return request('health_cmp_manGetDiseaseInfoDetail', body);
}

// 疾病百科-预览文章
export function getContentPreviewInfo (body) {
  return request('health_cmp_getContentPreviewInfo', body);
}

// 疾病百科-预览文章
export function getDiseaseInfoDraftDetail (body) {
  return request('health_cmp_getDiseaseInfoDraftDetail', body);
}

// 疾病百科-预览文章
export function updateDiseaseAuditStatus (body) {
  return request('health_cmp_updateDiseaseAuditStatus', body);
}

export function healthCmpQueryBodyParts(body){
  return request('health_cmp_queryBodyParts',body);
}

// 疾病症状内容查询
export function getDiseaseSymptoms (body) {
  return request('health_cmp_queryContentDrafts', body);
}

// 症状名模糊查询
export function getsSymptomsName (body) {
  return request('fuzzyQueryBySymptomName', body);
}
// 写手端获取草稿列表
export function getUserDraft (body) {
  return request('health_cmp_queryUserContentDrafts', body);
}

// 查询内容质量客观主观和总质量    typeList:  [30] 图文  [31] 视频  [29] 总质量
export function queryDictionaries(body) {
  return request('health_cmp_queryDictionaries', body);
}

// 内容搬运 - 用户是否授权
export function isUserAuthorization(body) {
  return request('health_cmp_biz_isUserAuthorization', body);
}

// 内容搬运 - 用户授权
export function authorizeUser(body) {
  return request('health_cmp_biz_authorizeUser', body);
}

// 内容搬运 - 查询授权内容
export function queryAuthorizationContent(body) {
  return request('health_cmp_biz_queryAuthorizationContent', body);
}

// 内容搬运 - 查询创作者认证列表
export function listMediaCertifications(body) {
  return request('health_cmp_biz_listMediaCertifications', body);
}

// 内容搬运 - 提交自媒体认证
export function submitMediaCertification(body) {
  return request('health_cmp_biz_submitMediaCertification', body);
}

// 内容搬运 - 提交任务
export function submitTask(body) {
  return request('health_cmp_biz_submitTask', body);
}

// 内容搬运 - 分页查询任务列表
export function pageTaskRecords(body) {
  return request('health_cmp_biz_pageTaskRecords', body);
}

// 内容搬运 - 查询任务列表数量
export function countTaskRecords(body) {
  return request('health_cmp_biz_countTaskRecords', body);
}

// 内容搬运 - 任务重试
export function retryTask(body) {
  return request('health_cmp_biz_retryTask', body);
}

// 查询用户同步历史弹窗接口
export function queryWriterHisSyncConfirm(body) {
  return request('health_cmp_biz_writerHisSyncConfirm', body);
}

// 作者主站达人信息（写手端）
export function queryContentUserMapping(body) {
  return request('health_cmp_biz_getContentUserMapping', body);
}

// 交互域操作相关接口
export function saveSyncState(body) {
  return request('health_cmp_business_saveOperation', body);
}

// 图文视频楼层化结构接口
export function health_cmp_biz_writerQueryContentFloor(body) {
  return request('health_cmp_biz_writerQueryContentFloor', body);
}

